<template>
 <div class="dib">
   <span class="text option-style" v-html="text">
     <!-- {{text}} -->
   </span>
</div>
</template>

<script>
export default {
  name: 'AnswerLang',
  props: ['text'],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {

  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
.text {
  font-size: 30px;
  font-weight: 400;
  color: #000;
  white-space: break-spaces;
}
.is-disabled {
  .text {
    color: #C0C4CC;
  }
}
.answer-pc {
  .dib {
    padding-right: 10px;
    .text {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerLang.vue